/* Fiocco Nero: product image zooms in under the mouse and returns to normal when the mouse leaves. No clicks.
   Only on devices with a real mouse; phones keep the normal swipe gallery. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var SCALE = 2.2;
  var css = document.createElement('style');
  css.textContent = '[data-fn-hover-zoom] .Carousel__Cell{overflow:hidden;cursor:zoom-in}' +
    '[data-fn-hover-zoom] .Carousel__Cell img{transition:transform .25s ease;will-change:transform}';
  document.head.appendChild(css);
  function bind(root) {
    root.addEventListener('mousemove', function (e) {
      var cell = e.target.closest('.Carousel__Cell'); if (!cell) return;
      var img = cell.querySelector('img'); if (!img) return;
      var r = cell.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(' + SCALE + ')';
    });
    root.addEventListener('mouseleave', function () {
      root.querySelectorAll('.Carousel__Cell img').forEach(function (img) { img.style.transform = ''; });
    });
    root.addEventListener('mouseout', function (e) {
      var cell = e.target.closest && e.target.closest('.Carousel__Cell');
      if (cell && !cell.contains(e.relatedTarget)) { var img = cell.querySelector('img'); if (img) img.style.transform = ''; }
    });
  }
  function run() { document.querySelectorAll('[data-fn-hover-zoom]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
